const gForms = function () {
    var forms = document.getElementsByClassName('gform_wrapper');
    if (!forms) {
        return;
    }
    for (let i = 0, j = forms.length; i < j; i++) {
        findSelect(forms[i]);
        findRadios(forms[i]);
        removeButtons(forms[i]);
    }
};

const findSelect = function (form) {
    if (!form) {
        return;
    }

    let selects = form.getElementsByTagName('SELECT');
    if (!selects) {
        return;
    }
    for (let i = 0, j = selects.length; i < j; i++) {

        let select = selects[i],
            field = select.parentNode.parentNode.nextSibling;

        // Default hidden
        field.style.display = 'none';

        select.addEventListener('change', function () {
            let label = this.options[this.selectedIndex].text;
            if (label !== 'Anders...') {
                field.style.display = 'none';
            } else {
                field.style.display = 'block';
            }
        });
    }
};

const findRadios = function (form) {
    if (!form) {
        return;
    }

    let radios = form.getElementsByTagName('INPUT'),
        radio = [];

    if (!radios) {
        return;
    }

    let togglePage = form.querySelector('.js-togglePage');

    // Get inputType Radios
    for (let i = 0, j = radios.length; i < j; i++) {
        if (radios[i].type == 'radio') {
            radio = radio.concat(radios[i]);
        }
    }

    for (let i = 0, j = radio.length; i < j; i++) {
        let el = radio[i];
        el.addEventListener('change', function () {
            if (el.checked === true && el.value === 'Adres- en/of mailgegevens zijn anders dan onder Praktijkgegevens' && !togglePage.classList.contains('show')) {
                togglePage.classList.add('show');
            } else if (el.checked === true && el.value === 'Adres- en mailgegevens: zie onder Praktijkgegevens' && togglePage.classList.contains('show')) {
                togglePage.classList.remove('show');
            }
        });
    }
};

const removeButtons = function (form) {
    if (!form) {
        return;
    }

    let buttons = form.querySelectorAll('.button');
    for (let i = 0, j = buttons.length; i < j; i++) {
        let button = buttons[i],
            value = button.value.toLowerCase();

        if (value === 'vorige' || value === 'volgende') {
            button.parentNode.removeChild(button);
        }
    }
};

export default gForms;

